import React, { memo } from "react";
import { Box, Grid } from "@chakra-ui/layout";
import { Item } from "../item";
import { Spinner } from "@chakra-ui/react";
import { IItemsProps } from "./items.types";

const LoadingSpinner = () => (
  <Box display="flex" justifyContent="center" m={10}>
    <Spinner />
  </Box>
);

const itemClick = (e: any, getGiphyGifData: any) => {
  const returnJson = {
    action: "create",
    type: "gif",
    file: e.images.downsized.url,
    mp4: e.images.original_mp4.mp4,
  };
  getGiphyGifData(returnJson);

  if (window.vlogr) {
    window.vlogr.addData(1, JSON.stringify(returnJson));
  }
  if (window.webkit) {
    window.webkit.messageHandlers.addData.postMessage(returnJson);
  }
};

export const Items = memo(
  ({
    items,
    columnN = 2,
    getGiphyStickersData,
    onDragStart,
    onDragEnd,
  }: IItemsProps) => {
    return (
      <>
        <Grid templateColumns={`repeat(${columnN}, 1fr)`} gap="8px">
          {items.map(({ url, ...gif }: any, i: any) => {
            return (
              <Item
                key={i}
                gif={gif}
                onClick={() => itemClick(items[i], getGiphyStickersData)}
                onDragStart={(event: React.DragEvent<HTMLDivElement>) => {
                  if (onDragStart) {
                    onDragStart(event, {
                      action: "create",
                      type: "gif",
                      file: items[i].images.downsized.url,
                      mp4: items[i].images.original_mp4.mp4,
                    });
                  }
                }}
                onDragEnd={(
                  event: React.DragEvent<HTMLDivElement>,
                  data: any
                ) => {
                  onDragEnd(event, data);
                }}
                name={""}
              />
            );
          })}
        </Grid>
        {items.map((itemID: any) => {
          if (itemID.id! == undefined) {
            return <LoadingSpinner />;
          } else {
            return <></>;
          }
        })}
      </>
    );
  }
);
